import React, { FormEvent, useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Input,
  Col,
  Card,
  CardBody,
  Row,
  Label,
} from "reactstrap";
import { Edit } from "react-feather";
import { toastr } from "react-redux-toastr";
import api from "../../services/api";
import { AxiosError } from "axios";
import { ModalHistoricoJustificativa } from "../ModalHistoricoJustificativa";
import Loading from "../Loading";

interface ModalProps {
  rash?: string;
  isRedirect?: boolean;
}

interface justificativasProps {
  historicoDeJustificativasInseridas_arr: string[];
  id: string;
  idCryptografado: string;
  opcoesDeJustificativas: string[];
  textoDaNotificacacao: string;
  tipoDoPonto: string;
  grafico?: string;
}
export const ModalJustificativaInterno = ({
  rash,
  isRedirect = false,
}: ModalProps) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const dataAtual = new Date();
  dataAtual.setDate(dataAtual.getDay() - 32);
  const [outra, setOutra] = useState(false);
  const [userResponse, setUserResponse] = useState("");
  const [otherJustification, setOtherJustification] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [loading, setLoading] = useState(false);

  const [justificativas, setJustificativas] = useState<justificativasProps>(
    {} as justificativasProps
  );

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (isSubmitting) return;

    try {
      const justification = (outra ? otherJustification : userResponse).trim();

      if (justification !== "") {
        setIsSubmitting(true);
        await api.post(`/justificativa/justification/${rash}`, {
          justification,
        });

        toastr.info("Sucesso", "Justificativa inserida com sucesso!");
        toggle();
      } else {
        toastr.warning("Alerta", "Todos os campos precisam ser preenchidos!");
      }
    } catch (error) {
      const axiosError = error as AxiosError<{ message?: string }>;
      toastr.error("Error", axiosError.response?.data?.message || "Error ao inserir");
    } finally {
      setIsSubmitting(false);
    }
  }

  function selectOutro() {
    setOutra(true);
    setOtherJustification("");
  }
  useEffect(() => {
    api
      .post(`/justificativa/${rash}`)
      .then((response) => setJustificativas(response.data))
      .finally(() => setLoading(true));
  }, [rash]);

  return loading ? (
    <>
      {isRedirect ? (
        <Button color="primary" className="mr-1 mb-1" onClick={toggle} outline>
          <Edit style={{ width: "1rem", marginTop: "-5px" }} /> Justificar
        </Button>
      ) : (
        <Button color="link" onClick={toggle}>
          <Edit style={{ width: "1rem", marginTop: "-5px" }} />
        </Button>
      )}

      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>Justificativa</ModalHeader>
        <ModalBody>
          <Row sm={12} style={{ justifyContent: "center" }}>
            <Card style={{ width: "50rem" }}>
              <CardBody>
                <form onSubmit={handleSubmit}>
                  {justificativas.grafico &&
                    justificativas.grafico.length > 0 && (
                      <Col sm={12}>
                        <img
                          src={justificativas.grafico}
                          alt="Gráfico"
                          style={{ width: "100%", display: "flex" }}
                        />
                      </Col>
                    )}

                  <Col sm={12}>
                    <p
                      style={{
                        marginLeft: -10,
                      }}
                    >
                      <b>Alerta:</b>
                    </p>
                    <p
                      style={{
                        marginLeft: -10,
                        textAlign: "justify",
                      }}
                    >
                      {justificativas.textoDaNotificacacao}
                    </p>
                  </Col>
                  <Col
                    style={{
                      display: "flex",
                      justifyContent: "right",
                    }}
                    sm={12}
                  >
                    <ModalHistoricoJustificativa rashModal={rash} />
                  </Col>

                  <Col sm={12}>
                    <p
                      style={{
                        marginLeft: -10,
                      }}
                    >
                      <b>Escolha a opção que descreve o ocorrido:</b>
                    </p>
                  </Col>

                  <FormGroup row>
                    <Col sm={12}>
                      <div className="custom-controls-stacked">
                        {justificativas.opcoesDeJustificativas?.map(
                          (opcaoJustificativa, index) => (
                            <FormGroup check>
                              <Input
                                type="radio"
                                key={index}
                                onChange={() => setOutra(false)}
                                className="radioButton"
                                id={`justificativa-${index}`}
                                name="justificativa"
                                value={opcaoJustificativa}
                                onClick={() =>
                                  setUserResponse(opcaoJustificativa)
                                }
                              />
                              <Label>{opcaoJustificativa}</Label>
                            </FormGroup>
                          )
                        )}

                        <FormGroup check>
                          <Input
                            type="radio"
                            className="radioButton"
                            id="justificativa-100"
                            name="justificativa"
                            value="Outra"
                            onClick={() => selectOutro()}
                          />
                          <Label>Outra</Label>
                        </FormGroup>
                      </div>
                    </Col>
                    {outra && (
                      <Col sm={12}>
                        <Input
                          type="textarea"
                          className="outra"
                          id="justificativa"
                          name="justificativa"
                          required
                          value={otherJustification}
                          onChange={(e) =>
                            setOtherJustification(e.target.value)
                          }
                          maxLength={300}
                          style={{
                            width: "100%",
                            height: "8rem",
                            fontStyle: "normal",
                            textAlign: "left",
                            margin: 0,
                            padding: 0,
                            paddingLeft: 10,
                            paddingBottom: 40,
                            justifyContent: "start",
                            marginTop: 10,
                            fontSize: "1rem",
                            overflow: "hidden",
                            resize: "none",
                          }}
                          autoFocus
                        />
                        <div
                          style={{
                            textAlign: "right",
                            fontSize: "0.85rem",
                            color: "#6c757d",
                            marginTop: 4,
                          }}
                        >
                          {otherJustification.length}/300
                        </div>
                      </Col>
                    )}

                    <Col sm={12}>
                      <Button
                        disabled={isSubmitting}
                        style={{
                          width: "100%",
                          backgroundColor: "#262F3D",
                          marginTop: 10,
                          alignItems: "center",
                          textAlign: "center",
                          justifyItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {isSubmitting ? "Salvando..." : "Salvar"}
                      </Button>
                    </Col>
                  </FormGroup>
                </form>
              </CardBody>
            </Card>
          </Row>
        </ModalBody>
      </Modal>
    </>
  ) : (
    <Loading width={10} height={10} color="primary" />
  );
};
